export const BEGIN_CERTIFICATE_TEXT = "-----BEGIN CERTIFICATE-----";

export const END_CERTIFICATE_TEXT = "-----END CERTIFICATE-----";

export const SSO_CALLBACK_URL_DEV =
  "https://remo-conference-dev.firebaseapp.com/__/auth/handler";

export const SSO_CALLBACK_URL_PRODUCTION =
  "https://remo-conference.firebaseapp.com/__/auth/handler";

export const SSO_ENTITY_ID_DEV = "dev.remo-conference.appspot.com";

export const SSO_ENTITY_ID_PRODUCTION = "live.remo.co";
